angular.module('licensure.internal')
    .directive('internalGutter', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/gutter/gutter.html',
            replace: true
        };
    }])
;